
    <svg-icon [class]="class" [src]="src"></svg-icon>
  


// WEBPACK FOOTER //
// ./src/app/@compartidos/components/svg/svg.component.ts.SvgComponent.html